<script setup>
import { useWebSiteStore } from '@/stores/web-site.store'
import { useChips } from '@/composables/chips'
import { useRateCard } from '@/composables/rate-card'
import { useArchive } from '@/composables/archive'
import ListItem from '@/components/shared/ListItem.vue'

defineProps({
  staff: {
    type: Object,
    required: true,
  },
})

const webSiteStore = useWebSiteStore()
const { getTagChips, getGroupChips } = useChips()
const { priceLabel } = useRateCard()
const { archivedChip } = useArchive()

const getLabel = (s) => {
  const firstField = webSiteStore.filterSortFields['staffs']?.sortFields.filter(x => x.order !== null).sort((a, b) => a.order || Math.infinity - b.order || Math.infinity)
  const fullName = firstField && firstField.length && firstField[0].field === 'first_name' ? `${s.first_name} ${s.name}` : `${s.name} ${s.first_name}`
  return s.code ? `${s.code} - ${fullName}` : fullName
}

const getCaptionChips = (s) => [
  ...getGroupChips(s.groups),
  ...getTagChips(s.tags),
  s.archived ? archivedChip : null,
].filter(Boolean)
</script>

<template>
  <list-item
    v-bind="$attrs"
    :avatar="staff.avatar_file || staff.avatar_url"
    avatar-icon="mdi-account"
    :label="getLabel(staff)"
    :caption="staff.warehouse_name || undefined"
    :caption-chips="getCaptionChips(staff)"
    :right-label="priceLabel(staff, true)"
    :disabled="staff.archived"
  >
    <template v-if="$slots.avatar" #avatar>
      <slot name="avatar" />
    </template>
    <template v-if="$slots.right" #right>
      <slot name="right" />
    </template>
  </list-item>
</template>
